import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'time' })
export class TimePipe implements PipeTransform {

  transform(value1: any, args?: any): any {
    const value = value1.toFixed(2);
    const minutes = Math.floor(value / 60);
    // We are not taking into account milliseconds
    const seconds = Math.round(value % 60);
    return minutes > 0 ? `${minutes}m${seconds}s` : `${seconds}s`;
  }

}
